export default __webpack_public_path__ + "static/media/Bangles-Making-Charge-List.efb6656b.jpg";